const dashboardLink = (sessionId) =>
  sessionId ? `/apps/in/dashboard/${sessionId}` : '/apps/in/archives';

const hasArchiveScope = (accessFilters) =>
  (Array.isArray(accessFilters?.planIds) && accessFilters.planIds.length > 0) ||
  (Array.isArray(accessFilters?.folderIds) && accessFilters.folderIds.length > 0);

export const getMenuGroups = ({ sessionId, accessFilters = {}, roles = [] }) => {
  const isAdmin = roles.includes('ROLE_ADMIN') || roles.includes('ROLE_SUPER_ADMIN');
  const canOrganize = isAdmin || roles.includes('ROLE_EDITED');
  const canImport = canOrganize || roles.includes('ROLE_ASSIST');

  const groups = [
    {
      key: 'archives',
      label: 'Archives',
      items: [
        {
          label: !canOrganize && hasArchiveScope(accessFilters) ? 'Mes archives' : 'Vue d’ensemble',
          icon: 'ri-stack-line',
          to: dashboardLink(sessionId),
          exact: true,
          activePaths: ['/apps/in/archives'],
          activePrefixes: [
            '/apps/in/archives/detail/',
            '/apps/in/archives/add',
          ],
        },
        {
          label: 'Recherche et consultation',
          icon: 'ri-search-2-line',
          to: '/apps/in/archives/search',
        },
        ...(canOrganize ? [{
          label: "Dossiers d’archive",
          icon: 'ri-folder-5-line',
          to: '/apps/in/dossiers-archives',
        }] : []),
      ],
    },
  ];

  if (canOrganize) {
    groups.push(
      {
        key: 'organisation',
        label: 'Organisation',
        items: [
          { label: 'Plan de classement', icon: 'ri-git-branch-line', to: '/apps/in/plan-classement' },
          { label: "Profils d’archive", icon: 'ri-profile-line', to: '/apps/in/archives/profils' },
          { label: 'Règles de conservation', icon: 'ri-shield-check-line', to: '/apps/in/archives/regles-conservation' },
          { label: 'Services producteurs', icon: 'ri-building-4-line', to: '/apps/in/services-producteurs' },
        ],
      }
    );
  }

  if (canImport) {
    groups.push({
      key: 'suivi',
      label: 'Suivi & contrôle',
      items: [
        {
          label: 'Tâches incomplètes',
          icon: 'ri-task-line',
          to: '/apps/in/archives/taches-incompletes',
          activePrefixes: ['/apps/in/archives/import'],
        },
        ...(isAdmin ? [{
          label: 'Régularisation des empreintes',
          icon: 'ri-fingerprint-line',
          to: '/apps/in/archives/integrite-regularisation',
        }] : []),
        ...(canOrganize ? [{
          label: 'Qualité des métadonnées',
          icon: 'ri-check-double-line',
          to: '/apps/in/archives/qualite-metadonnees',
        }, {
          label: 'Journal & logs', icon: 'ri-file-list-3-line', to: '/apps/in/archives/logs',
        }] : []),
      ],
    });
  }

  if (canOrganize) {
    groups.push({
      key: 'administration',
      label: 'Administration',
      items: [
        ...(isAdmin ? [{
          label: 'Utilisateurs & rôles',
          icon: 'ri-account-circle-line',
          to: '/apps/in/users-accounts/page/1',
          activePrefixes: ['/apps/in/users-accounts/', '/apps/in/users/'],
        }] : []),
        
      ],
    });
  }

  return groups;
};
